// src/lib/device-id.ts
/** معرّف ثابت لهذا الجهاز/المتصفح — يتولّد مرة واحدة ويُخزَّن في localStorage (يبقى عبر تبويبات/جلسات
 * كتيرة، بعكس رمز الدخول نفسه اللي في sessionStorage). يُرسل في هيدر X-Device-Id مع كل طلب حتى غير
 * الموثّق، عشان الباك إند يقدر يربط كل جلسة دخول بجهازها الحقيقي (لازم لميزة "جهاز واحد فقط"). */
const KEY = "adman.deviceId";

function generate(): string {
  return typeof crypto.randomUUID === "function" ? crypto.randomUUID().replace(/-/g, "") : `d${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
}

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const next = generate();
    localStorage.setItem(KEY, next);
    return next;
  } catch {
    // متصفح خاص/تخزين معطّل — نولّد معرّف لمرة واحدة بلا تخزين بدل ما نكسر الطلب
    return generate();
  }
}
